export const DOMISERVE_CONTACT_URL = "https://www.domiserve.com/507/votre-demande.htm"
export const DOMISERVE_GUIDES_UTILISATION_URL = "https://www.domiserve.com/355/guides-d-utilisation.htm#c2317"
export const DOMISERVE_BESOIN_AIDE_URL = "https://www.domiserve.com/344/besoin-d-aide.htm"

export const DOMISERVE_TARIF_PRESTATIONS_URL = "https://www.domiserve.com/Statics/PDF/Tarif_CESU_Domiserve.pdf"

export const DOMISERVE_CESU_ACCOUNT_NOTICE_URL =
    "https://www.domiserve.com/fileadmin/www.domiserve.com/MEDIA/PDF/Notice_Compte_CESU_2020.pdf"

export const DOMISERVE_DONNEES_PERSONNELLES_URL =
    "https://www.domiserve.com/Statics/PDF/DOMISERVE_-_Politique_de_Protection_des_Donnees_Personnelles.pdf"

export const DOMISERVE_SAP_URL =
    "https://www.domiserve.com/454/nos-solutions/les-services-a-la-personne-et-l-accompagnement-social.htm"

export const DOMISERVE_PRESTATIONS_SAP_URL =
    "https://www.domiserve.com/543/nos-solutions/nos-prestations-de-services-a-la-personne.htm"

export const DOMISERVE_AICI_URL =
    "https://www.domiserve.com/538/nos-solutions/les-services-a-la-personne-et-l-accompagnement-social/avance-immediate-de-credit-d-impot.htm"

export const DOMISERVE_RAPPORT_ACCESSIBILITE_EBU =
    "https://ara.numerique.gouv.fr/rapport/wQjqOpvFReO7WaLqkbozo/details-des-non-conformites"

export const CRCESU_HOME_URL = "www.cr-cesu.fr"
export const CRCESU_CONTACT_URL = "https://www.cr-cesu.fr/menu-haut/contactez-nous.html"
export const CRCESU_PERSONAL_AREA = "https://espacepersonnel.cr-cesu.fr/#/signUp"

export const PARTICULIER_URSSAF_URL = "https://www.particulier.urssaf.fr"

export const CESU_URSSAF_URL = "www.cesu.urssaf.fr"

export const PAJ_EMPLOI_URSSAF = "www.pajemploi.urssaf.fr"

export const BENEFICIARY_AREA_URL = "https://espace-beneficiaire.edomiserve.com"
export const FINANCEUR_AREA_URL = "https://espace-financeur.edomiserve.com"
export const PRESTADOM_URL = "https://prestadom.edomiserve.com"
export const SIDOMI_URL = "https://espace-beneficiaire-service.edomiserve.com"
export const TRADE_AREA_URL = "https://espace-echange.edomiserve.com"
export const INTERVENANT_AREA_URL = "https://espace-intervenant.edomiserve.com"

export const APPLICATION_UNAVAILABLE_URL = "https://www.domiserve.com/indisponibilite"

export const SITE_MINESTERIEL_EMPLOI_DOMICILE_URL = "https://www.impots.gouv.fr/particulier/emploi-domicile"
